import React from 'react';
import { Form, Input, Radio, Switch } from 'antd';

import formatName from '../formatName';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export class TextForm extends React.Component {
  state = {
    nameTouched: !!this.props.name,
  }

  onChange = (changed, nameHasBeenTouched) => {
    const { onChange, onValid, control: prevControl } = this.props;
    const control = { ...prevControl, ...changed };
    const isValid = this.isValid(control);
    onValid(isValid);
    onChange(control);

    if (nameHasBeenTouched) {
      this.setState({ nameTouched: true });
    }
  }

  isValid (control) {
    const { controls, control: { label: prevLabel, name: prevName } } = this.props;
    const { label = prevLabel, name = prevName } = control;
    const isNameSame = name === prevName;
    const isNameValid = isNameSame || !controls.find(({ name: cName }) => cName === name);
    return label && name && isNameValid;
  }

  render () {
    const {
      control: {
        label = '',
        name = '',
        placeholder = '',
        required,
        long,
      },
    } = this.props;
    const { nameTouched } = this.state;
    const { onChange } = this;

    return (
      <React.Fragment>
        <FormItem
          label="Libellé du champ"
          extra="Libellé qui sera indiqué au-dessus du champ texte pour indiquer à l'utilisateur le contenu attendu."
          required
        >
          <Input
            value={label}
            onChange={({ target: { value } }) => onChange({
              label: value,
              name: nameTouched ? name : formatName(value),
            })}
          />
        </FormItem>
        <FormItem
          label="Texte de remplacement - Placeholder"
          extra="Texte qui sera affiche (en gris) dans la champ visant à apporter des précisions à l'utilisateur sur le contenu attendu."
        >
          <Input
            value={placeholder}
            onChange={({ target: { value } }) => onChange({ placeholder: value })}
          />
        </FormItem>
        <FormItem
          label="Champ obligatoire"
        >
          <Switch
            checked={!!required}
            onChange={checked => onChange({ required: checked })}
          />
        </FormItem>
        <FormItem
          label="Nom du champ"
          required
          extra="Il s'agit du nom donné en base de donnée, il ne sera donc pas visible pour l'utilisateur. Cette étiquette pourra être utilisé lors de la création de template PDF."
        >
          <Input
            value={formatName(name)}
            onChange={({ target: { value } }) => onChange({ name: formatName(value) }, true)}
          />
        </FormItem>
        <FormItem
          label="Type de champ texte"
          required
        >
          <RadioGroup onChange={e => onChange({ long: e.target.value })} defaultValue={long}>
            <RadioButton value={false}>Court</RadioButton>
            <RadioButton value>Long</RadioButton>
          </RadioGroup>
        </FormItem>
      </React.Fragment>
    );
  }
}

export default TextForm;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/Control/TextForm.js